<template>
  <div class="second-section ">
      <h2 class="subtitle slideLeft" >Deja tu Huella</h2>
       <h2 class="subtitle slideRight" style="margin-bottom: -0.4rem; color:  #00d371;">Sin dejar Huella</h2>
      <div class="bakckground-gs">
        <div class="md-layout md-gutter md-alignment-center " style="text-align: justify; width: 95%; margin: auto;" >
          <div class="md-layout-item item-line md-small-size-100 left-side ">

            <div class=" div-circle-container md-layout md-alignment-center slideLeft">
              <div class="md-layout-item md-size-20">
                <span class="circle">
                  <img src="@/assets/mano.png" alt="Mano" srcset="">
                </span>
              </div>
              <div class="md-layout-item md-layout-text">
                <h2><strong>Declara tu compromiso</strong> <br /> con el medio ambiente</h2>
              </div>
            </div>

            <div class="div-circle-container md-layout md-alignment-center slideLeft">
              <div class="md-layout-item md-size-20">
                <span class="circle">
                  <img src="@/assets/enchufe.png" alt="Enchufe" srcset="">
                </span>
              </div>
              <div class="md-layout-item md-layout-text" >
                <h2><strong>Identifica alternativas</strong> <br />   de reducción de costo</h2>
              </div>
            </div>

            <div class="div-circle-container md-layout md-alignment-center slideLeft">
              <div class="md-layout-item md-size-20 ">
                <span class="circle">
                  <img src="@/assets/mundo_green.png" alt="Mundo verde" srcset="">
                </span>
              </div>
              <div class="md-layout-item md-layout-text" >
                <h2><strong>Reduce riesgos</strong> <br />   por legislaciones ambientales</h2>
              </div>
            </div>
          </div>

          <div class="md-layout-item item-line md-small-size-100 right-side slideRight" >

            <div class="div-circle-container md-layout md-alignment-center" >
              <div class="md-layout-item md-size-20 ">
                <span class="circle">
                  <img src="@/assets/bolsa.png" alt="Bolsa" srcset="">
                </span>
              </div>
              <div class="md-layout-item md-layout-text">
                <h2 ><strong>Identifica oportunidades</strong> <br /> de reducción de impactos <br /> ambientales</h2>
              </div>
            </div>

            <div class="div-circle-container md-layout md-alignment-center slideRight">
              <div class="md-layout-item md-size-20 ">
                <span class="circle" style="margin-top: -1em">
                  <img src="@/assets/corazon.png" alt="Corazon" srcset="" >
                </span>
              </div>
              <div class="md-layout-item md-layout-text" style="margin-top: -15px;">
                <h2 ><strong>Se preferido por tus credenciales </strong> <br /> ambientales por consumidores  responsables</h2>
              </div>
            </div>

            <div class="div-circle-container md-layout md-alignment-center slideRight" id="circle-last" style="">
              <div class="md-layout-item md-size-20 ">
                <span class="circle">
                  <img src="@/assets/promueve.png" alt="Promueve" srcset="">
                </span>
              </div>
              <div class="md-layout-item md-layout-text" >
                <h2><strong>Promueve una economía</strong> <br /> sustentable</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
var slideLeft = {
    distance: '550%',
    origin: 'left',
    duration: 1550,
    opacity: 0.1,
    delay: 20
}
var slideRight = {
    distance: '550%',
    origin: 'right',
    duration: 1550,
    opacity: 0.1,
    delay: 20
}
import Formulario from './Form.vue'
export default {
  components: {Formulario},
  mounted () {
    
  }
}
</script>

<style>
.second-section {
  background-color: #f2f2f2;
  padding: 10vw 0vw 0 0vw;
  width: 100%;
}
.item-line {
  margin-left: 4vw;
}

div.item-line  h2 {
  margin: auto auto auto 1rem;
  padding: 0 !important;
  font-weight: normal;
  font-size: 1.5vw;
  line-height: 1.3;
  letter-spacing: -0.66px;
  text-align: left;
}
.circle {
  display: inherit;
  border-radius: 100%;
  width: 6vw;
  height: 6vw;
  box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.16);
  background-color: #00d371;
  margin-bottom: -1rem;
}
.div-circle-container {
  margin: 5vw 2vw 5vw 0vw;
}
.right-side {
  margin-left: 4vw;
}
.left-side {
  margin-right: 4vw;
}

.circle img {
  margin: auto;
  width: 100%;
}

#circle-last {
  margin-top: 5vw !important
}
.bakckground-gs{ 
  background-image: url("../assets/huella-transparente.png");
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: top;
  background-size: 40%;
  padding-bottom: 3vw;
}


</style>